<div class="size-guide-block">
    @for (blockMeasureYourself of measureYourself; track blockMeasureYourself) { @if( isPdfBlock(blockMeasureYourself))
    {
    <div [class]="SIZE_GUIDE_BLOCK">
        <h-block-pdf [blockMeasureYourself]="blockMeasureYourself"></h-block-pdf>
    </div>
    } @if( isStepsBlock(blockMeasureYourself)) {

    <div [class]="SIZE_GUIDE_BLOCK"> <h-block-steps [blockMeasureYourself]="blockMeasureYourself"></h-block-steps></div>

    } @if( isImageBlock(blockMeasureYourself)){

    <div [class]="SIZE_GUIDE_BLOCK"> <h-block-image [blockMeasureYourself]="blockMeasureYourself"></h-block-image></div>

    } @if( isTableBlock(blockMeasureYourself)) {

    <div [class]="SIZE_GUIDE_BLOCK_TABLE">
        <h-block-table [content]="blockMeasureYourself"></h-block-table>
    </div>

    } }
</div>
